<template>
  <div>
    <div class="d-flex align-center mb-8">
      <div>
        <v-btn @click="$router.go(-1)" class="left-arrow" icon>
          <v-icon>mdi-arrow-top-left</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <span class="heading">Downloaded Reports</span>
      </div>
    </div>
    <downloadedReports />
  </div>
</template>
<script>
import downloadedReports from "@/components/Trending/ResearchReport/downloadedReports.vue";
export default {
  name: "ResearchReport",
  data() {
    return {
      is_sebi_registered: false,
    };
  },
  components: {
    downloadedReports,
  },
  computed: {},
  mounted() {
    this.getUserDetail();
  },
  methods: {},
};
</script>
<style scoped>
.heading {
  color: hsl(0deg 0% 0% / 87%);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.left-arrow {
  transform: rotate(-45deg);
}
</style>
